module.exports = __webpack_public_path__ + "static/parade-2020-house42-797003f84c76d6132d7a0609806c0582.jpg";